/**
 * Auth entry-point configuration
 *
 * REACT_APP_PUBLIC_AUTH_ENABLED=false (default / production launch)
 *   → All Sign In / Sign Up CTAs redirect to Cal.com demo booking.
 *   → Direct visits to /login, /sign-up etc. on this domain hit the
 *     branded 404 page (no auth routes exist in this marketing app).
 *
 * REACT_APP_PUBLIC_AUTH_ENABLED=true (when product is ready to accept signups)
 *   → Auth CTAs point to the live application at cleanbid.ai.
 *
 * To restore public sign-in / sign-up on Netlify:
 *   Dashboard → Site Settings → Environment Variables
 *   → Set REACT_APP_PUBLIC_AUTH_ENABLED=true → trigger redeploy
 *
 * Internal testing:
 *   The cleanbid.ai application is a separate domain and is unaffected.
 *   Internal team can access https://cleanbid.ai/login directly at any time.
 */

import { CALCOM_DEMO_URL } from "./demo";

export const PUBLIC_AUTH_ENABLED =
  process.env.REACT_APP_PUBLIC_AUTH_ENABLED === "true";

const APP_SIGN_IN_URL = "/login";
const APP_SIGN_UP_URL = "/signup";

/** Internal SPA path for Sign In CTAs. */
export const getAuthSignInURL = () => APP_SIGN_IN_URL;

/** Internal SPA path for Sign Up / Get Started CTAs. */
export const getAuthSignUpURL = () => APP_SIGN_UP_URL;

/**
 * data-event values for analytics attribution.
 * When auth is disabled, events are tagged *_demo_redirect so you can
 * measure which CTA generated a scheduled call.
 */
export const SIGNIN_EVENT = PUBLIC_AUTH_ENABLED ? "signin" : "signin_demo_redirect";
export const SIGNUP_EVENT = PUBLIC_AUTH_ENABLED ? "signup" : "signup_demo_redirect";
